import { Component } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { StyleClassModule } from 'primeng/styleclass';
import { AppConfigurator } from './app.configurator';
import { LayoutService } from '../service/layout.service';
import { ButtonModule } from 'primeng/button';

@Component({
    selector: 'app-topbar',
    standalone: true,
    imports: [RouterModule, CommonModule, StyleClassModule, AppConfigurator,ButtonModule],
    templateUrl: './app.topbar.html',
})
export class AppTopbar {
    items!: MenuItem[];

    constructor(public layoutService: LayoutService) {}

    toggleDarkMode() {
        this.layoutService.layoutConfig.update((state) => ({ ...state, darkTheme: !state.darkTheme }));
    }

    openTwitch() {
        window.open('https://www.twitch.tv/nueschtkoenner', '_blank');
    }

    openFacebook() {
        window.open('https://www.facebook.com/profile.php?id=61583820869132&locale=de_DE', '_blank');
    }

    openDiscord() {
        window.open('https://discord.gg/9X2a4YZmCW', '_blank');
    }

    isDarkMode() {
        return this.layoutService.isDarkTheme();
    }

}
